import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, firebaseProjectId, /* googleProvider, signInWithRedirect, */ sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink, /* getRedirectResult */ } from '../firebase';
import { useAuth } from '../AuthContext';
import './SignPage.css';

/* Google Auth - commented out for now
// Official Google "G" Logo SVG
const GoogleLogo = () => (
  <svg className="google-logo" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      fill="#4285F4"
    />
    <path
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      fill="#34A853"
    />
    <path
      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      fill="#FBBC05"
    />
    <path
      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      fill="#EA4335"
    />
  </svg>
);
*/

const getReturnUrl = () => {
  const returnUrl = localStorage.getItem('returnAfterSignIn');
  if (returnUrl) {
    localStorage.removeItem('returnAfterSignIn');
    return returnUrl;
  }
  return '/profile';
};

const SignPage = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const { currentUser, loading } = useAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (!loading && currentUser) {
      navigate(getReturnUrl());
    }
  }, [currentUser, loading, navigate]);

  /* Google Auth - commented out for now
  useEffect(() => {
    getRedirectResult(auth)
        .then((result) => {
          if (result) {
            navigate('/profile');
          }
        })
        .catch((error) => {
          console.error("Error with redirect sign-in", error);
        });
  }, [navigate]);
  */

  useEffect(() => {
      // Check if the user is signing in with an email link
      if (isSignInWithEmailLink(auth, window.location.href)) {
        let email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
          email = window.prompt('Please provide your email for confirmation');
        }
        signInWithEmailLink(auth, email, window.location.href)
          .then(() => {
            window.localStorage.removeItem('emailForSignIn');
            navigate(getReturnUrl());
          })
          .catch((error) => {
            console.error("Error signing in with email link", error);
          });
      }
    }, [navigate]);

  const handleEmailSignIn = (e) => {
    e.preventDefault();
    const actionCodeSettings = {
      url: window.location.origin + '/signup',
      handleCodeInApp: true,
    };

    sendSignInLinkToEmail(auth, email, actionCodeSettings)
      .then(() => {
        window.localStorage.setItem('emailForSignIn', email);
        alert('Sign-in link sent! Check your email.\n\nHint: check your spam if you can\'t find it!');

        if (process.env.REACT_APP_USE_AUTH_EMULATOR === 'true') {
          const emulatorUrl = `http://localhost:9099/emulator/v1/projects/${firebaseProjectId}/oobCodes`;
          fetch(emulatorUrl)
            .then((response) => response.json())
            .then((data) => {
              const latest = (data.oobCodes || [])
                .filter((code) => code.email === email && code.requestType === 'EMAIL_SIGNIN')
                .slice(-1)[0];
              if (!latest) {
                return;
              }
              const link = latest.oobLink || `${actionCodeSettings.url}?mode=signIn&oobCode=${encodeURIComponent(latest.oobCode)}`;
              console.info('[Auth Emulator] Email sign-in link:', link);
            })
            .catch((error) => {
              console.warn('Failed to fetch auth emulator email link', error);
            });
        }
      })
      .catch((error) => {
        console.error("Error sending email link", error);
        alert('Failed to send sign-in link. Please try again.');
      });
  };

  /* Google Auth - commented out for now
  const handleGoogleSignIn = () => {
    signInWithRedirect(auth, googleProvider)
      .catch((error) => {
        console.error("Error with Google sign-in", error);
      });
  };
  */

  return (
    <div className="sign-container">
      <div className="sign-card">
        <h2 className="sign-header">Almost there!!!</h2>

        <form className="sign-form" onSubmit={handleEmailSignIn}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="sign-button">
            Continue with Email
          </button>
        </form>

{/* Google Auth - commented out for now
        <div className="sign-divider">
          <span className="sign-line"></span>
          <span className="sign-or">or</span>
          <span className="sign-line"></span>
        </div>

        <div className="sign-google-container">
          <button className="sign-google-button" onClick={handleGoogleSignIn}>
            <GoogleLogo />
            Continue with Google
          </button>
        </div>
*/}
      </div>
    </div>
  );
};

export default SignPage;
